<template>
  <v-app id="inspire">
    <v-main>
      <v-container>
        <v-row align="center" justify="center">
          <img src="/logo.png" alt width="200" />
        </v-row>
      </v-container>
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-form @submit.prevent="login">
                <v-toolbar color="primary" dark flat>
                  <v-toolbar-title>Acceso</v-toolbar-title>
                  <div class="flex-grow-1"></div>
                </v-toolbar>
                <v-card-text>
                  <v-text-field
                    label="Usuario"
                    v-model="user"
                    prepend-icon="mdi-account"
                    type="text"
                  ></v-text-field>
                  <v-text-field
                    label="Contraseña"
                    prepend-icon="mdi-lock"
                    type="password"
                    v-model="password"
                  ></v-text-field>
                </v-card-text>
                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn type="submit" color="primary">Acceder</v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    user: "",
    password: ""
  }),
  methods: {
    login() {
      this.openLoader();
      window.setTimeout(() => {
        const request = this.sendRequest(
          this.$store.state.apiUrl + "login",
          { username: this.user, password: this.password },
          "POST"
        );
        request
          .then(({ message, data }) => {
            window.localStorage.setItem("token", data.token);
            window.localStorage.setItem("user", JSON.stringify(data.user));
            this.showSuccessMessage(message);
            this.$store.state.user = data.user;
            window.setTimeout(() => {
              window.location = "/";
            }, 3000);
          })
          .finally(() => this.closeLoader());
      }, 200);
    }
  }
};
</script>
